const TAB    = 9;
const ENTER  = 13;
const SHIFT  = 16;
const ESCAPE = 27;
const LEFT   = 37;
const UP     = 38;
const RIGHT  = 39;
const DOWN   = 40;

let Keyboard = {
  isEscape(evt) {
    return evt.keyCode === ESCAPE;
  },

  isEnter(evt) {
    return evt.keyCode === ENTER;
  },

  isUpArrow(evt) {
    return evt.keyCode === UP;
  },

  isDownArrow(evt) {
    return evt.keyCode === DOWN;
  },

  isUpOrDownArrow(evt) {
    return this.isUpArrow(evt) || this.isDownArrow(evt);
  },

  isLeftArrow(evt) {
    return evt.keyCode === LEFT;
  },

  isRightArrow(evt) {
    return evt.keyCode === RIGHT;
  },

  isArrow(evt) {
    return this.isUpOrDownArrow(evt) || this.isLeftOrRightArrow(evt);
  },

  isLeftOrRightArrow(evt) {
    return this.isLeftArrow(evt) || this.isRightArrow(evt);
  },

  isBackTab(evt) {
    return evt.keyCode === TAB && evt.shiftKey;
  },

  isNextTab(evt) {
    return evt.keyCode === TAB && !evt.shiftKey;
  },

  isTab(evt) {
    return evt.keyCode === TAB;
  },

  isShift(evt) {
    return evt.keyCode === SHIFT;
  }
};

module.exports = Keyboard;